// Journal / seasonal posts — the editorial voice of the shop.
// In production: Cosmos, server-rendered for SEO/GEO.

export const JOURNAL = [
  {
    id: "j-exotics-irish-damp",
    slug: "exotics-that-love-irish-damp",
    title: "Five exotics that actually love the Irish damp",
    date: "2026-05-12",
    readingTime: "6 min",
    excerpt:
      "Everyone treats our climate as a problem to fight. For the right plants, that soft damp air is exactly what they'd choose.",
    cover:
      "https://images.unsplash.com/photo-1502082553048-f009c37129b9?auto=format&fit=crop&w=1200&q=70",
    body: [
      "There's a habit, among people selling plants, of pretending Ireland is somewhere it isn't. Glossy catalogues full of cacti and Mediterranean herbs, sold to people whose gardens spend nine months a year somewhere between 'moist' and 'frankly wet'.",
      "I'd rather work with the weather than against it. The plants below don't tolerate Irish damp — they actively prefer it, and they look every bit as exotic as the things that'll sulk and rot by November.",
      "Start with the tree fern (Dicksonia antarctica). Prehistoric, dramatic, and happiest in the kind of soft, shaded, humid corner our climate hands out for free. Add a Fatsia for glossy structure that shrugs off frost, and a few Calatheas inside for the steamy bathroom, and you've got a glasshouse look without a glasshouse bill.",
      "The trick isn't fighting the climate. It's choosing plants that were waiting for it.",
    ],
  },
  {
    id: "j-arrives-healthy",
    slug: "how-we-pack-plants",
    title: "How we make sure a plant arrives alive",
    date: "2026-04-28",
    readingTime: "4 min",
    excerpt:
      "The single biggest fear in buying a plant online is opening a crushed box of compost. Here's exactly how we pack to make sure that never happens.",
    cover:
      "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=1200&q=70",
    body: [
      "Every plant is watered the day before it ships, never the morning of — a soggy rootball in transit is asking for trouble.",
      "The pot is bagged and taped at the soil line so nothing spills, then braced inside the box so it can't move. Foliage is loosely sleeved, not crushed. We ship early in the week so nothing sits in a depot over the weekend — a lesson straight from how the best Irish growers operate.",
      "And every order includes a photo of exactly what we packed, so you know what to expect before you open the box. If anything arrives less than healthy, we make it right. That promise is the whole point.",
    ],
  },
  {
    id: "j-pet-safe",
    slug: "pet-safe-plants-guide",
    title: "A genuinely pet-safe plant shelf",
    date: "2026-04-10",
    readingTime: "5 min",
    excerpt:
      "You don't have to choose between a cat and a jungle. A run-through of our favourite non-toxic exotics.",
    cover:
      "https://images.unsplash.com/photo-1463320726281-696a485928c7?auto=format&fit=crop&w=1200&q=70",
    body: [
      "Half the questions we get start with 'but is it safe for the cat?'. It's the right question — a surprising number of popular houseplants are mildly toxic if chewed.",
      "The good news is you can build a lush, varied, pet-safe shelf without compromise. Calathea orbifolia for drama, String of Hearts to trail, Pilea for shareable charm, Peperomia for the windowsill. All non-toxic, all interesting, none of them a worry.",
      "Filter the shop by 'pet-safe' and you'll only ever see plants that are safe around a curious nose.",
    ],
  },
];

export const getPost = (slug) => JOURNAL.find((p) => p.slug === slug);
